import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { DomainBidderDTO } from 'features/globalSetup/api/types/domainBidderDTO'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'

export const DOMAIN_BIDDER_FOR_SELECT_FRAGMENT: TypedDocumentNode<DomainBidderDTO> = gql`
  ${ALERT_FRAGMENT}

  fragment DomainBidderForSelectFragment on DomainBidder {
    id
    domain {
      id
      alerts {
        ...AlertFragment
      }
      name
    }
  }
`
